export default function Hero2() {
  return (
    <div className="px-4 pt-4 my-5 text-center border-bottom">
      <h2 className="display-5 fw-bold">
        Mais de 1.500 universidades e empresas inovadoras confiam nos treinamentos desenvolvidos pela CAPSIM
      </h2>
    </div>
  );
}
